import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import {
    Intention,
    LinkClickedEvent,
    useToggleState,
} from '@news-mono/web-common'
import React, { useEffect, useState } from 'react'
import { StyledParagraph } from '../../publication/Paragraph/Paragraph.styled'

export interface ParagraphProps {
    text: string
    intentions?: Intention[]
    tag?: 'p'
    onEvent: (event: LinkClickedEvent) => void
}

export const Paragraph: React.FC<ParagraphProps> = (props) => {
    const toggles = useToggleState()

    const isFontIncreasedOnTheWestArticle = isFeatureEnabled(
        toFeatureState(toggles),
        'the-west-increased-article-font',
    )
    const [isIncreasedFont, setFontIncrease] = useState(false)

    useEffect(() => {
        setFontIncrease(isFontIncreasedOnTheWestArticle)
    }, [isFontIncreasedOnTheWestArticle])

    return (
        <StyledParagraph
            tag="p"
            text={props.text}
            intentions={props.intentions}
            onEvent={props.onEvent}
            isIncreasedFont={isIncreasedFont}
        />
    )
}
Paragraph.displayName = 'Paragraph'
